module.exports = __webpack_public_path__ + "static/circle-fd77187702f4ff334cde84f93695c49c.png";